import { Card, CardContent } from "@/components/ui/card";
import { Layers, Code, ShoppingBag, PenTool } from "lucide-react";
import { useI18n } from "@/i18n";

export function UseCasesSection() {
  const { t } = useI18n();

  const cases = [
    { icon: Layers, title: t.home.creators, desc: t.home.creatorsDesc },
    { icon: Code, title: t.home.developers, desc: t.home.developersDesc },
    { icon: ShoppingBag, title: t.home.indieSellers, desc: t.home.indieSellersDesc },
    { icon: PenTool, title: t.home.writers, desc: t.home.writersDesc },
  ];

  return (
    <section className="w-full py-20 md:py-28 bg-white">
      <div className="mx-auto max-w-[1152px] px-6">
        <h2 className="text-3xl md:text-4xl font-medium tracking-tight text-center text-[#0a1733] mb-16">
          {t.home.whoFor}
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {cases.map((item, i) => {
            const Icon = item.icon;
            return (
              <Card
                key={i}
                className="group relative overflow-hidden bg-white border border-[#e5e5e5] rounded-[10px] shadow-none hover:-translate-y-1 transition-transform duration-300"
              >
                {/* Left accent border */}
                <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#ff4a01] opacity-0 group-hover:opacity-100 transition-opacity" />
                <CardContent className="p-6 flex gap-4">
                  <div className="flex-shrink-0 flex items-center justify-center w-12 h-12 rounded-[10px] bg-[#f5f5f5]">
                    <Icon className="size-6 text-[#0a1733]" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-[#0a1733] mb-1">{item.title}</h3>
                    <p className="text-sm text-[#7a818e] leading-relaxed">{item.desc}</p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
}
